import { render } from "./LikeshopBanner.vue?vue&type=template&id=a6afbbf6&scoped=true"
import script from "./LikeshopBanner.vue?vue&type=script&lang=js"
export * from "./LikeshopBanner.vue?vue&type=script&lang=js"

import "./LikeshopBanner.vue?vue&type=style&index=0&id=a6afbbf6&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6afbbf6"]])

export default __exports__